import { ReactElement } from 'react';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import { getRowCardOrders } from '../helpers/cards';
import { RowCardContainer } from './components/styles';
import { WaterCard } from './components/WaterCard';
import { Energy } from './Energy';

interface RowCardsOverviewProps {
  hasWater: boolean,
  hasEnergy: boolean,
  loading: boolean,
  order: number
}

export function RowCardsOverview({
  hasEnergy,
  hasWater,
  loading,
  order,
}: Readonly<RowCardsOverviewProps>): ReactElement {
  const { water } = getRowCardOrders(hasWater);
  const direction = hasWater ? 'row' : 'column';
  const isMobile = useMediaQuery('(max-width: 768px)');
  const expanded = !isMobile && !hasEnergy && !loading;

  return (
    <RowCardContainer direction={loading ? 'row' : direction} style={{ order }}>
      <WaterCard
        hasWater={hasWater}
        loading={loading}
        order={water}
        expanded={expanded}
      />
      <Energy
        hasEnergy={hasEnergy}
        hasWater={hasWater}
        loading={loading}
      />
    </RowCardContainer>
  );
}
